import styled from "styled-components";
import { motion } from "framer-motion";
import { fontMixin } from "../../../styles";

interface CP_ContainerProps {
	$size: number;
}

export const CP_Container = styled(motion.div)<CP_ContainerProps>`
	position: relative;
	width: ${({ $size }) => $size}px;
	height: ${({ $size }) => $size}px;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const CP_SVG = styled(motion.svg)`
	position: absolute;
	inset: 0;
	transform: rotate(-90deg);

	circle {
		transition: stroke-dashoffset 0.8s cubic-bezier(0.16, 1, 0.3, 1);
	}
`;

export const CP_Text = styled(motion.div)`
	position: relative;
	z-index: 1;
	color: #ffffff;
	${fontMixin({ size: 11, weight: 400 })};
`;
